import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

interface EditingPositionsState {
    counts: Record<string, number>
}

const initialState: EditingPositionsState = {
    counts: {},
}

const editingPositionsSlice = createSlice({
    name: 'editingPositions',
    initialState,
    reducers: {
        beginEditingPosition(state, action: PayloadAction<string>) {
            const positionId = action.payload
            state.counts[positionId] = (state.counts[positionId] ?? 0) + 1
        },
        endEditingPosition(state, action: PayloadAction<string>) {
            const positionId = action.payload
            const nextCount = (state.counts[positionId] ?? 0) - 1

            if (nextCount <= 0) {
                delete state.counts[positionId]
            } else {
                state.counts[positionId] = nextCount
            }
        },
    },
})

export const { beginEditingPosition, endEditingPosition } = editingPositionsSlice.actions
export default editingPositionsSlice.reducer

export const selectIsPositionEditing = (state: RootState, positionId: string): boolean =>
    Boolean(state.editingPositions.counts[positionId])

export const selectIsAnyPositionEditing = (state: RootState, positionIds: string[]): boolean =>
    positionIds.some(positionId => Boolean(state.editingPositions.counts[positionId]))
